import { i18n } from "../i18n/i18n";

import React, { useEffect, useState } from 'react'
import { useMediaDevices } from 'react-media-devices'
import { useZxing } from 'react-zxing'
import Select, { SelectOption } from './Select'
import Heading from './Heading'
import Icon from './Icon'

interface Props {
  onScan(value: string): void
  onClose(): void
}

function ModalScan (props: Props) {
  const [devices, setDevices] = useState<SelectOption[]>([])
  const [device, setDevice] = useState('')
  const constraints: globalThis.MediaStreamConstraints = {
    video: true,
    audio: false
  }
  const media = useMediaDevices({ constraints })
  const { ref } = useZxing({
    paused: !device,
    deviceId: device,
    onDecodeResult (result) {
      const code = result.getText()
      props.onScan(code)
      props.onClose()
    }
  })
  const handleMediaDevicesChange = () => {
    if (media.devices && media.devices.length) {
      const videoDevices = media.devices.filter(device => {
        return device.kind === 'videoinput'
      })
      const deviceOptions = videoDevices.map(device => {
        return { name: device.label, value: device.deviceId }
      })
      setDevices(deviceOptions)
      if (deviceOptions.length) {
        const backCamera = deviceOptions.find(device => {
          return device.name.toLowerCase().includes('back')
        })
        const firstDevice = deviceOptions[0]
        const device = backCamera || firstDevice
        setDevice(device.value)
      }
    }
  }
  const handleInputChange = (name: string, value: string) => {
    if (name === 'device') setDevice(value)
  }
  useEffect(handleMediaDevicesChange, [media.devices])
  return (
    <div className='w-screen h-screen bg-black absolute inset-0 bg-opacity-20 z-50'>
      <div
        className='bg-[white] h-fit w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 p-5 m-auto my-5'>
          <div className='flex justify-between items-center'>
            <Heading text={i18n("Scan QR code or barcode")} className='mb-2' />
            <Icon
              name='close'
              size='medium'
              color='gray'
              onClick={props.onClose} />
          </div>
        <Select
          name="device"
          options={devices}
          value={device}
          onChange={handleInputChange}
          label='Choose camera' />
        <video ref={ref} />
      </div>
    </div>
  )
}

export default ModalScan
